import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import English from './locales/translations/english.json'
import हिंदी from './locales/translations/hindi.json'
import മലയാളം from './locales/translations/malayalam.json'
import தமிழ் from './locales/translations/tamil.json'
import తెలుగు from './locales/translations/telugu.json'
import ಕನ್ನಡ from './locales/translations/kannada.json'
import অসমীয়া from './locales/translations/assamese.json'
import বাংলা from './locales/translations/bengali.json'
import ગુજરાતી from './locales/translations/gujarati.json'
import मराठी from './locales/translations/marathi.json'
import ଓଡ଼ିଆ from './locales/translations/odia.json'
import ਪੰਜਾਬੀ from './locales/translations/punjabi.json'

const resources = {
  English,
  हिंदी,
  മലയാളം,
  தமிழ்,
  తెలుగు,
  ಕನ್ನಡ,
  অসমীয়া,
  বাংলা,
  ગુજરાતી,
  मराठी,
  ଓଡ଼ିଆ,
  ਪੰਜਾਬੀ,
}

export const availableLanguages = Object.keys(resources)
// eslint-disable-next-line
i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  defaultNS: 'common',
  fallbackLng: 'English',
  lng: localStorage.lng,  
})
